{
    "actions": {
        "row": {
            "update_label": "Modifier le libellé",
            "delete": "Supprimer la règle"
        }
    },
    "filter": {
        "placeholder": {
            "contract": "Filtrer par contrat",
            "bank_code": "Filtrer par code banque",
            "rank": "Filtrer par rang",
            "recipient": "Filtrer par environnement",
            "legal_name": "Filtrer par nom de l'organisation",
            "partner": "Filtrer par ID Partenaire",
            "extra_1": "Filtrer par extra 1",
            "extra_2": "Filtrer par extra 2",
            "label": "Filtrer par libellé"
        }
    },
    "keys": {
        "contract": "Contrat",
        "bank_code": "Code banque",
        "rank": "Rang",
        "recipient": "Environnement",
        "legal_name": "Nom de l'organisation",
        "partner": "ID Partenaire",
        "application": "Application",
        "extra_1": "Extra 1",
        "extra_2": "Extra 2",
        "label": "Libellé"
    },
    "modal": {
        "update_label": {
            "title": "Modifier le libellé ",
            "text": "Libellé",
            "success": "Modification de la règle réussie avec succès !",
            "error": "Une erreur est survenue lors de la modification de la règle"
        },
        "delete": {
            "title": "Supprimer la règle",
            "text": "Vous êtes sur le point de supprimer cette règle.",
            "success": "Suppression de la règle réussie avec succès !",
            "error": "Une erreur est survenue lors de la suppression de la règle",
            "warning": "Veuillez confirmer la suppression."
        },
        "import": {
            "explanations": {
                "header": "Il est possible de réaliser des opérations par téléversement de fichier. Le fichier est au format CSV et doit contenir les 10 colonnes suivantes :",
                "action": "action : Cette colonne correspond à l'action à effectuer sur chaque ligne. Les deux valeurs possibles sont \"AJOUTER\" ou \"SUPPRIMER\".",
                "recipient": "recipient : Environnement sur lequel envoyer les notifications",
                "partner": "partner : ID Partenaire sur laquelle le TPE est configuré (visible dans l'onglet \"Organisations partenaires\")",
                "contract": "contract : Numéro de contrat à 7 chiffres",
                "rank": "rank : Permet d’identifier un rang particulier (exemple \"001\"). Afin d’identifier \"tous les rangs\", il suffit de laisser le champ vide.",
                "bankCode": "bankCode : Code banque acquéreur",
                "application": "application : Identifie l’application du contrat. Vous pouvez mentionner soit \"CBEMV\" pour CB Proximité soit \"CBCLESS\" pour CB Sans contact soit \"CBVAD\" pour CB vente à distance.",
                "extra1": "extra1 : Champ supplémentaire qui a été créé initialement lors du paramétrage Push Payment API (optionnel)",
                "extra2": "Champ supplémentaire qui a été créé initialement lors du paramétrage Push Payment API (optionnel)",
                "label": "Vous pouvez mentionner un libellé à chaque règle (optionnel)"
            },
            "confirmation": "Cette opération va ajouter {{add}} règle(s) et supprimer {{delete}} règle(s). Souhaitez-vous continuer ?",
            "success": "Opérations réussies avec succès !",
            "error": {
                "header": "Nous avons pu traiter {{rulesProcessed}} règle(s), les règles suivantes n'ont pas pu être traitées :",
                "invalid_file": "Ce fichier n'est pas compatible (.csv uniquement)",
                "UNEXPECTED_ERROR": "Une erreur est survenue, veuillez réessayer plus tard."
            }
        }
    },
    "rank": {
        "all": "Tous les rangs"
    }
}